var _path, _path2, _path3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHtml(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-30 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 0 31.800781 448.101562 194.398438 63.898438 194.398437-63.898438 31.800782-448.101562zm0 0",
    fill: "#ff7816"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m452.398438 0-31.800782 448.101562-194.398437 63.898438v-512zm0 0",
    fill: "#ff4b00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m367.5 136h-222.300781l5.398437 75h211.503906l-12.902343 181.597656-123 41.101563-123-41.101563-4.199219-60.597656h60l1.199219 16.5 66 21.898438 66-21.898438 5.398437-77.5h-203.097656l-13.800781-195h291zm0 0",
    fill: "#ececf1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#e2e2e7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m362.101562 211-12.902343 181.597656-123 41.101563v-63.300781l66-21.898438 5.398437-77.5h-71.398437v-60zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m371.699219 76-4.199219 60h-141.300781v-60zm0 0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.8daa82ad3cc2762b91e3b4c50ab587c0.svg";
export { ForwardRef as ReactComponent };